import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import logo from "../../assets/image/logo.svg";

function NotFound() {
    return (
        <div className="min-h-safe-screen bg-background text-secondary flex flex-col items-center justify-center px-6 text-center space-y-6">
            {/* Logo */}
            <img src={logo} alt="Logo" className="w-48 h-auto" />

            {/* Titolo */}
            <h1 className="text-6xl font-bold text-primary">404</h1>

            {/* Sottotitolo */}
            <h2 className="text-2xl font-semibold">Pagina non trovata</h2>

            {/* Descrizione */}
            <p className="text-muted max-w-md">
                La pagina che stai cercando non esiste o è stata spostata.
            </p>

            {/* Bottone */}
            <Link
                to="/"
                className="inline-flex items-center gap-2 px-6 py-3 bg-primary text-black font-semibold rounded-full hover:scale-105 transition"
            >
                <ArrowLeft className="w-4 h-4" />
                Torna alla Home
            </Link>
        </div>
    );
}

export default NotFound;